export const dataScore = {
  type: 'number',
};
